import { connect } from 'react-redux';
import { actions } from 'app-webtech-core/actions';
import { ErrorBoundary as ErrorBoundaryComponent } from '../components/ErrorBoundary';

const mapStateToProps = undefined;

const mapDispatchToProps = (dispatch) => ({
  logError: (error, info) => dispatch(actions.application.undefinedError(error, info)),
});

export const ErrorBoundary = connect(mapStateToProps, mapDispatchToProps)(ErrorBoundaryComponent);
